import { Badge } from '@/components/ui/badge'
import ComposioAppIcon from '@/frontend/components/Integrations/ComposioAppIcon'
import type { OrgIntegration } from '@/frontend/pages/Dashboard/DigitalWorkers/types'

export default function ManagedConnection({ integration, rowRef }: {
  integration: OrgIntegration
  rowRef?: (node: HTMLDivElement | null) => void
}) {
  const management = integration.admin_management
  if (!management) return null

  return <div ref={rowRef} className="flex items-start gap-3 py-3 first:pt-0 last:pb-0" data-admin-managed="true">
    <ComposioAppIcon logo={integration.logo ?? null} name={integration.provider_label} className="mt-0.5 h-5 w-5 shrink-0" />
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-2">
        <p className="min-w-0 flex-1 break-words text-sm font-medium text-foreground">{integration.provider_label}</p>
        <Badge variant={integration.status === 'failed' ? 'destructive' : 'secondary'}>{management.status_label}</Badge>
      </div>
      <p className="mt-0.5 text-xs text-muted-foreground">{management.label}</p>
      <p role="status" className="mt-0.5 text-xs text-muted-foreground">{management.description}</p>
    </div>
  </div>
}
